export enum AmountIndicator {
    TotalAllowance = 1,
    TotalCharge = 2,
    NoAllowanceOrCharge = 3,
    AmountDueAllowance = 4,
    AmountDueCharge = 5,
}
